import * as types from "./mutation-types";

export const store = ({ commit }, data) => {
  commit(types.FEATURE_FLAGS_STORE, data);
};

export const destroy = ({ commit }) => {
  commit(types.FEATURE_FLAGS_DESTROY);
};

export default {
  store,
  destroy,
};
